import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import "./GestionProyecto.css";

interface GestionItem {
  titulo: string;
  descripcion: string;
}

interface GestionProyectoProps {
  gestion: GestionItem[];
  alcance: GestionItem[];
}

export default function GestionProyecto({ gestion, alcance }: GestionProyectoProps) {
  const { t } = useTranslation();
  return (
    <>
      <div className="componente-extra">
        <h3>{t("gestion.gestion_title")}</h3>
        <div className="contenedor-cajas">
          {Array.isArray(gestion) && gestion.map((item, idx) => (
            <div className="grupo-mini" key={idx}>
              <div className="caja-mini">{item.titulo}</div>
              <motion.p
                className="descripcion-mini"
                initial={{ opacity: 0, y: -20 }}
                whileInView={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                viewport={{ once: false, amount: 0.3 }}
                transition={{ duration: 0.6 }}
              >
                {item.descripcion}
              </motion.p>
            </div>
          ))}
        </div>
      </div>

      <div className="componente-extra">
        <h3>{t("gestion.alcance_title")}</h3>
        <div className="contenedor-migracion2">
          {Array.isArray(alcance) && alcance.map((grupo, idx) => (
            <div className="grupo-migracion2" key={idx}>
              <div className="caja-mini2">{grupo.titulo}</div>
              <motion.p
                className="descripcion-mini"
                initial={{ opacity: 0, y: -20 }}
                whileInView={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                viewport={{ once: false, amount: 0.3 }}
                transition={{ duration: 0.6 }}
              >
                {grupo.descripcion}
              </motion.p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
